module.exports = __webpack_public_path__ + "static/media/content-10.88f79e0c.svg";